import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
// import './styles.module.css'
import styled from 'styled-components'

const pushAfter = [
  [0, 0, 0],
  [22, 28, 25],
  [47, 53, 50],
  [72, 78, 75],
  [92, 98, 95],
  [99, 100, 100],
]

export const ReactVideoAndTracking = ({
  videoUrls,
  articleId,
  trackingInterval = 15,
  videoTitle,
  videoPubDate,
  debug = false,
}: {
  videoUrls: string[]
  articleId: string
  trackingInterval?: number
  videoTitle?: string
  videoPubDate?: string
  debug?: boolean
}) => {
  const [vidDuration, setViDuration] = useState()
  const [vidPercent, setVidPercent] = useState(0)
  const [lastPercentPushed, setLastPercentPushed] = useState(0)
  const [vidPlaying, setVidPlaying] = useState(false)
  const [showPlaceholder, setShowPlaceholder] = useState(true)



  useEffect(() => {
    if (vidPercent > 0) {
      if (vidPercent > lastPercentPushed) {
        let pushValue = lastPercentPushed
        pushAfter.forEach((e) => {
          if (vidPercent >= e[0] && vidPercent <= e[1]) pushValue = e[2]
        })
        if (pushValue > lastPercentPushed) {
          setLastPercentPushed(pushValue)

        }
      }
    }
  }, [vidPercent])

  return (
    <div className='ReactVideoAndTracking'>
      <div className='aspect'>

        <VideoContainer>
          <ReactPlayer
            playing={!showPlaceholder}
            playsinline
            width='100%'
            height='100%'
            controls
            onPlay={() => {
              setVidPlaying(true)
           
            }}
            onPause={() => setVidPlaying(false)}
            onProgress={(e) => {
              if (vidDuration) {
                setVidPercent(Math.round((e.playedSeconds * 100) / vidDuration))
              }
           
            }}
            url={videoUrls}
          />
        </VideoContainer>
      </div>
   
    </div>
  )
}

const VideoContainer = styled.div`
padding:0;
line-height: 0;
  height: 100%;
`
